import React, { useEffect, useRef, useState } from "react";
// import { useNavigate } from "react-router-dom";
import { getData, patchData, postData } from "../../Service/ApiMethod";
import { COMPANY_LIST, job_category_url, RECURITER_PROFILE } from "../../Service/service";
import AWS from 'aws-sdk';
// import AddDropdownPopup from "../../common/AddDropdownPopup";
// import AddCompanyPopup from "../../common/AddCompanyPopup";
import AddCompany from "../PostVaccancy/AddCompany";
import { useTranslation } from "react-i18next";
import Loader from "../login/Loader";
import { lang } from "../../lang";

const EditProfile = (props) => {
  // const [firstName, setFirstName] = useState();
  // const [lastName, setLastName] = useState();
  // const [phone, setPhone] = useState();
  // const [email, setEmail] = useState();
  // const [image, setImage] = useState();
  // const [company, setCompany] = useState();
  // const [bio, setBio] = useState();
  // const [address, setAddress] = useState();
  // const [aboutCompany, setAboutCompany] = useState();
  const [userProfileDetail, setUserProfileDetail] = useState({})
  const [companyList, setCompanyList] = useState()
  const [companyID, setCompanyID] = useState()
  const [imageFile,  setImageFile] = useState()
  const [imageURL, setImageURL] = useState()
  // const [image, setImage] = useState()
  // const [addCat, setAddCat] = useState(false);
  // const [category, setCategory] = useState();
  const [error, setError] = useState();
  const [newCompany , setNewCompany] = useState();
  const [ companyImage, setCompanyImage] = useState();
  const [companyLocation , setCompanyLocation] = useState();
  const[ aboutCompany , setAboutCompany] = useState();
  const[ companyWebsite , setCompanyWebsite] = useState();
  const [addCompany, setAddCompany] = useState(false);
  const [loaderStart, setLoaderstart] = useState(false)
  const [ln,setLn] = useState('en')
  const [upComp, setUpComp] = useState(false);
  const [isDisable, setIsdiable] = useState(false)
  const {t} = useTranslation()

  useEffect(()=>{
    if(localStorage.getItem("language") != null){
      setLn(localStorage.getItem("language"))
    }
  },[])
  



  // const [userProfilePhone, setUserProfilePhone] = useState()


  // const setClosePopup = props?.setUpdateProfilePopup
  // const profileData = props?.profileData
  const setEditProfile = props?.submit || props?.setUpdateProfilePopup
  const userdetail = props?.userData || props?.profileData
  const user_company_name = props?.userData?.company_name == undefined ? "Select Company":props?.userData?.company_name
  // let userPhone = props?.userData?.user?.phone || props?.profileData?.user?.phone
  console.log('userdetail',userdetail)
  console.log('user_company_name', user_company_name)

  // const phonedetail = ()=>{
  //   setUserProfilePhone(userPhone)
  // }

  // const URL = 'https://jobportalrecruiter.atwpl.com/'

  const initialState = {
      first_name: userdetail?.first_name,
      last_name: userdetail?.last_name,
      phone: userdetail?.user?.phone,
      email: userdetail?.email,
      image: userdetail?.image,
      company: userdetail?.company
      // company_name: userdetail?.company_name,
      // company_location: userdetail?.company_location,
      // about_company: userdetail?.about_company,
      // company_website: userdetail?.company_website
  }

  const getUserDetail = ()=>{
    setUserProfileDetail(initialState)
  }

  console.log('userProfileDetail', userProfileDetail)

 
  let imageobj = {
    first_name: userProfileDetail?.first_name || userdetail?.first_name,
    last_name: userProfileDetail?.last_name || userdetail?.last_name,
    email: userProfileDetail?.email || userdetail?.email,
    image: imageURL || userdetail?.image,
    company: companyID || userdetail?.company
  };

  console.log('imageObj', imageobj)

  var emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
  const handleUpdate = (url) => {
    // setLoaderstart(true)
    // let dataObj = {
    //   first_name: firstName ,
    //   last_name: lastName ,
    //   phone: phone ,
    //   email: email ,
    //   image: image,
    //   company_name: company,
    //   company_location: address,
    //   about_company: bio,
    // };
    let dataObj = {
      first_name: userProfileDetail?.first_name || userdetail?.first_name,
      last_name: userProfileDetail?.last_name || userdetail?.last_name,
      email: userProfileDetail?.email || userdetail?.email,
      image: url || userdetail?.image,
      // image: url,
      mobile_number:`${userdetail?.user?.phone}`,
      company: companyID || userdetail?.company,
      latitude:localStorage?.getItem("lat"),
      longitude:localStorage?.getItem("lng")
    };
    console.log("onnn",dataObj);
    if(!userProfileDetail?.first_name || !userdetail?.first_name){
      alert('Please Update your First Name')
      setLoaderstart(false)
    }else if(!userProfileDetail?.last_name || !userdetail?.last_name){
      alert('Please Update your Last Name')
      setLoaderstart(false)
    } else if(!userProfileDetail?.email){
      alert('Please Update Your Email')
      setLoaderstart(false)
    }else if (!emailPattern.test(userProfileDetail?.email)) {
      alert('Please Enter Correct Email')
      setLoaderstart(false)
    }else if (dataObj.image == null) {
      alert(lang && Object.keys(lang).length > 0 ? lang[ln]?.FinalFinal['Please Select Profile Picture']:"")
      setLoaderstart(false)
    }
    else if(dataObj.company == undefined || dataObj.company == "") {
      alert(lang && Object.keys(lang).length > 0 ? lang[ln]?.FinalFinal['Please select Company']:"")
      setLoaderstart(false)
    }
    else{
      console.log('dataObj12222', dataObj)
      patchData(dataObj, RECURITER_PROFILE)
        .then((response) => response.json())
        .then((data) => {
          setLoaderstart(false)
          console.log('update data', data?.data)
          setEditProfile(false)
          props?.getProileData()
        })
        .catch((err) => {
          setLoaderstart(false)
          console.log("Error in categories from Post Form", err);
          console.log(" code Error", err);
        });
    }
  }

  // const config = {
  //   bucket: 'catzapp-dev',
  //   region: 'eu-central-1',
  //   accessKey: 'AKIA2GWTBVL6WX6U75ZC',
  //   secretKey: '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',
  //   successActionStatus: 201,
  // }

//   const handleUploadImageFile = ()=>{
//     uploadFile(imageFile, )
//         .then(data => console.log('after upload image', data))
//         .catch(err => console.error(err))
// }

// -------------Add Company popup----------------

// const postCompany = async () => {
//     if (category) {
//       const catObj = {
//            company_name: newCompany,
//       company_image: companyImage,
//       company_location: companyLocation,
//       about_company: aboutCompany,
//       company_website: companyWebsite,
//       };
//       await postData(catObj, COMPANY_LIST)
//         .then((response) => response.json())
//         .then((data) => {
//           if (data.message !== "") {
//             alert(data?.message);
//           }
//           try {
//             console.log("category", data);
//           } catch (err) {
//             console.log("error hgappended", err);
//             setError(err.message, "email already exists");
//             alert("Eoorrror", err);
//           }
//         });
//     } else {
//       alert("Please fill all field")

//     }

//   };

// const postCompany = async () => {
//   const catObj = {
//     company_name: newCompany,
//     company_image: companyImage,
//     company_location: companyLocation,
//     about_company: aboutCompany,
//     company_website: companyWebsite,
//   };

//   if (!newCompany) {
//     alert("Company name Required");
//   } else if (!companyLocation) {
//     alert("Enter company location");
//   } else if (!aboutCompany) {
//     alert("enter few words about company ");
//   } else {
//     await postData(catObj, COMPANY_LIST)
//       .then((response) => response.json())
//       .then((data) => {
//         setAddCompany(false);
//         if (data.message !== "") {
//           alert(data?.message);
//         }
//         try {
//           console.log(data);
//         } catch (err) {
//           console.log("error hgappended", err);
//           setError(err.message, "email already exists");
//           alert("Eoorrror", err);
//         }
//       });
//   }
// };

  const getSelectedCandidate = () => {
    getData(COMPANY_LIST)
      .then((response) => response.json())
      .then((data) => {
        setCompanyList(data.data);
      })
      .catch((err) => {
        console.log("Error in categories from Post Form", err);
        console.log(" code Error", err);
      });
  };

  const handleSelectedCompany =(id)=>{
    setCompanyID(id)

  }

  // const handleUploadImage = ()=>{
  //   obj = {

  //   }

  //   fetch()
  // }


  // const handleUpdate = async (e) => {
  //   e.preventDefault();
  //   if (objItem.title === "") {
  //     alert("Title Required");
  //   } else if (postVaccancy.job_category === null) {
  //     alert("Enter Job Category");
  //   } else if (postVaccancy.skills === null) {
  //     alert("Enter skills");
  //   } else if (postVaccancy.experience === null) {
  //     alert("Enter experiance");
  //   } else if (objItem.job_description === "") {
  //     alert("enter Job Description ");
  //   } else if (objItem.work_location === "") {
  //     alert("Please Enter Work Location");
  //   } else if (objItem.contact_person_name === "") {
  //     alert("enter contact_person_name ");
  //   } else if (objItem.contact_number === "") {
  //     alert("Please Enter contact_number");
  //   } else if (objItem.compensation_details === "") {
  //     alert("enter compensation_details ");
  //   } else if (objItem.compensation_amount === "") {
  //     alert("Please compensation_amount");
  //   } else if (objItem.emp_details === "") {
  //     alert("enter emp_details ");
  //   } else if (objItem.no_of_vacancy === "") {
  //     alert("Please Enter no_of_vacancy");
  //   } else if (objItem.job_duration === "") {
  //     alert("enter job_duration ");
  //   } else if (objItem.urgent_vacancy === "") {
  //     alert("Please Enter Work Location");
  //   } else if (objItem.highest_degree === "") {
  //     alert("Please Enter Highest Degree");
  //   } else {
  //     await postData(objItem, vaccancy_url)
  //       .then((response) => response.json())
  //       .then((data) => {
  //         console.log(data, "vaccancy_url");

  //         if (data.message !== "") {
  //           console.log("from API ", data.error_message);
  //           // alert(data?.message);
  //         } else {
  //           console.log("'data.message' is not empthy");
  //         }
  //         try {
  //           if (data.error_message) {
  //             alert("Plese Fill All Fields");
  //           } else if (data.message) {
  //             alert(data.message);
  //             navigateToSuccess();
  //           }
  //         } catch (err) {
  //           console.log("error hgappended", err);
  //           setError(err.message, "email already exists");
  //           alert("Error", error);
  //         }
  //       });
  //   }
  // };

  const ref = useRef(null);
  useOutsideAlerter(ref);

  function useOutsideAlerter(ref) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          // props?.closeModalWrtOutsideClick && props?.closeModalWrtOutsideClick();
          // setClosePopup && setClosePopup(false)
          setEditProfile && setEditProfile(false)
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  const handleRecruiterImage = (e)=>{
   
    
    // var png = image.assets[0].fileName.endsWith(".png");
    // var jpg = image.assets[0].fileName.endsWith(".jpg");
    console.log(e.target.files[0]?.type,"file type")
    if(e.target.files[0]?.type == "image/png" || e.target.files[0]?.type == "image/jpg"|| e.target.files[0]?.type == "image/jpeg"){
      let s3 = new AWS.S3({
        accessKeyId: 'AKIA2GWTBVL6WX6U75ZC',
        secretAccessKey: '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',
        region: 'eu-central-1'
      });
  
      const params = {
        Bucket: 'catzapp-dev',
        Key: e.target.files[0]?.name,
        Body: e.target.files[0],
        ContentType: e.target.files[0]?.type || 'image/png',
        ACL: 'public-read'
      };
  
      s3.upload(params, (err, data) => {
        if (err) {
          console.log(err);
        } else {
          console.log(isDisable,`File uploaded successfully. ${data?.Location}`);
          
          setImageURL(data?.Location)
          setTimeout(()=>{
            setIsdiable(false)
            console.log(isDisable,"gfgfgfg")
          },1500)
        }
      })
    }else{
      alert("Only supporte .png and jpg")
    }
  
  }

  console.log('imageURL', imageURL)

  useEffect(() => {
    // handleUpdate()
    getUserDetail()
    getSelectedCandidate()
  }, []);
  useEffect(() => {
  
    getSelectedCandidate()
  }, [upComp]);


  return (
    <div className="blur-screen-full-area flex-center">
      {
    loaderStart == true || isDisable == true ? (<Loader/>):null
   }
      <div className="edit-profile" style={{position:'relative'}} >  
        <h2 className="heading mb-3 text-center">{t('Update Profile')}</h2>
        <div className="edit-profile-fields">
          <input
            className="edit-profile-input mb-2 w-100"
            type="text"
            placeholder={t("First Name")}
            value={userProfileDetail?.first_name}
            // defaultValue= {profileData?.first_name || userProfileDetail?.frist_name}
            // defaultValue= {userProfileDetail?.first_name}

            // onChange={(e) => setFirstName(e.target.value)}
            onChange={(e) => {
              let obj = { ...userProfileDetail };
              obj["first_name"] = e.target.value;
              console.log("checkOb",obj)
              setUserProfileDetail(obj);
             
            }}
          />
          <input
            className="edit-profile-input mb-2 w-100"
            type="text"
            placeholder={t("Last Name")}
            // value="lastName"
            // defaultValue= {profileData?.last_name || userProfileDetail?.last_name}
            value= {userProfileDetail?.last_name}

            // onChange={(e) => setLastName(e.target.value)}
            onChange={(e) => {
              let obj = { ...userProfileDetail };
              obj["last_name"] = e.target.value;
              setUserProfileDetail(obj);
            }}
          />

         
          <input
            className="edit-profile-input mb-2 w-100"
            type="email"
            placeholder={t("Enter Email")}
            // value="email"
            // defaultValue= {profileData?.email || userProfileDetail?.email}
            value= {userProfileDetail?.email}

            // onChange={(e) => setEmail(e.target.value)}
            disabled={userdetail?.login_type === "social_login" && true}
            onChange={(e) => {
              let obj = { ...userProfileDetail };
              obj["email"] = e.target.value;
              setUserProfileDetail(obj);
            }}
          />

         
{addCompany ? (
          <AddCompany
          setPopupClose= {setAddCompany}
          setUpComp={setUpComp}
          upComp={upComp}
          lag={ln}
        />
      ) : null}
                  <div className="mb-2 relative">
                    <select  name='Select Vacancy' onChange={(e) => handleSelectedCompany(e.target.value)} style={{paddingLeft: '13px',background:'#fff',width:'100%', marginBottom:'10px', height:'42px', borderRadius:"6px",border:'1px solid #dfe2e2'}}>
                      <option value={user_company_name} default>{user_company_name == "" ? lang && Object.keys(lang).length > 0 ? lang[ln]?.MyProfile["Select Company"]:"":user_company_name}</option>
                      {companyList?.map((item) =>
                 <option key={item?.id} value={item?.id} >{item?.company_name}</option>
                        )}
                        
                    </select>

                    <button
                      className=" btn btn-primary addFields " style={{height:"42px"}}
                      onClick={(e) => {
                    // setAddCat(true);
                        setAddCompany(true);
                        e.preventDefault();
                      }}
                    > 
                      {lang && Object.keys(lang).length > 0 ? lang[ln]?.Home['Add']:""}
                    </button>
                  </div>
                  
                    <p>{lang && Object.keys(lang).length > 0 ? lang[ln]?.YearMonth["Profile Image"]:""}</p>
           <input   accept="image/*" className="edit-profile-input mb-2 w-100 profileiMg" 
          type="File" onChange={(e)=>{
            var inputFi = document.querySelector('.profileiMg');
            var filePath = e.target.value.toLowerCase();
            var allowedExtensions = /(\.jpg|\.jpeg|\.png)$/i;
            if (!allowedExtensions.exec(filePath)) {
                alert(lang && Object.keys(lang).length > 0 ? lang[ln]?.YearMonth['Please upload file having extensions .jpeg/.jpg/.png only.']:"");
                inputFi.value = ""
                return false
            }else{

            // console.log('input type file', e.target.files[0])
            // console.log('input type url', (e.target.files[0]))
            // setImageFile(e.target.files[0])
            setIsdiable(true)
            handleRecruiterImage(e)
            }
            // handleUploadImage()
            // let obj = { ...userProfileDetail };
            //   obj["image"] = `${imageURL}`;
            //   setUserProfileDetail(obj);
          }}/>

          {
            imageURL == null? null:isDisable == true ? (<div style={{position:'absolute'}}><Loader/></div>):(<img src={imageURL} style={{width:100,height:100}}/>)
          }
  
      
          <div style={{display:'flex', justifyContent:'space-between', marginTop:'10px'}}>
            <button 
            disabled={isDisable}
            className="theme-btn" onClick={(e)=>{
              e.stopPropagation()
              handleUpdate(imageURL)
              // handleUploadImageFile()
              }}>
                {
                  isDisable == true ? t('Please wait...'):lang && Object.keys(lang).length > 0 ? lang[ln]?.MyProfile['Update']:""
                }
              {}
            </button>
            <button className="editprofilecancelbtn"
            // style={{backgroundColor:'gray', border:'2px solid gray'}}
            onClick={(e)=>{
              e.stopPropagation()
              setEditProfile(false)
              }}>
              {lang && Object.keys(lang).length > 0 ? lang[ln]?.Newtranslation['Cancel']:""}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditProfile;
